import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const SEV = { baja: "Baja", media: "Media", alta: "Alta" };
const blank = () => ({ element: "", description: "", severity: "media", recommendation: "" });

export const FindingsEditor = ({ wo, editable, onSaved }) => {
  const [rows, setRows] = useState(wo.findings || []);
  const [busy, setBusy] = useState(false);
  useEffect(() => setRows(wo.findings || []), [wo.findings]);
  const set = (i, k, v) => setRows((r) => r.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put(`/work-orders/${wo.id}/findings`, { findings: rows }); toast.success("Hallazgos guardados"); onSaved?.(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="findings-editor">
      {rows.map((f, i) => (
        <div key={f.id || i} className="grid gap-2 rounded-lg border border-border p-3 sm:grid-cols-2" data-testid={`finding-${i}`}>
          <Input placeholder="Elemento (ej. Cámara 3) *" value={f.element} disabled={!editable} onChange={(e) => set(i, "element", e.target.value)} data-testid={`finding-${i}-element`} />
          <select className="h-10 rounded-md border border-border bg-transparent px-2 text-sm" value={f.severity} disabled={!editable} onChange={(e) => set(i, "severity", e.target.value)} data-testid={`finding-${i}-severity`}>
            {Object.entries(SEV).map(([k, l]) => <option key={k} value={k}>Severidad {l}</option>)}
          </select>
          <Input placeholder="Descripción" value={f.description} disabled={!editable} onChange={(e) => set(i, "description", e.target.value)} data-testid={`finding-${i}-description`} />
          <div className="flex gap-2">
            <Input placeholder="Recomendación" value={f.recommendation} disabled={!editable} onChange={(e) => set(i, "recommendation", e.target.value)} data-testid={`finding-${i}-recommendation`} />
            {editable && <Button size="icon" variant="ghost" onClick={() => setRows((r) => r.filter((_, j) => j !== i))} data-testid={`finding-${i}-remove`}><Trash2 className="h-4 w-4" /></Button>}
          </div>
        </div>
      ))}
      {!rows.length && <p className="text-sm text-muted-foreground">Sin hallazgos registrados.</p>}
      {editable && (
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => setRows((r) => [...r, blank()])} data-testid="finding-add-button"><Plus className="mr-1 h-4 w-4" />Agregar hallazgo</Button>
          <Button onClick={save} disabled={busy || rows.some((f) => !f.element.trim())} data-testid="findings-save-button">Guardar hallazgos</Button>
        </div>
      )}
    </div>
  );
};
